import { useAuth } from '../contexts/AuthContext';

/**
 * useDemoMode — returns true for ALL demo accounts (admin, manager, worker, client).
 * Real customer accounts must NEVER be treated as demo users.
 * Detection uses isDemoUser from AuthContext which checks all VITE_DEMO_*_EMAIL env vars.
 */
export const useDemoMode = () => {
  const { isDemoUser } = useAuth();

  const isDemoMode = isDemoUser;

  const interceptWrite = (action, mockResult = { data: {}, error: null }) => {
    if (!isDemoMode) return null; // null = not intercepted, proceed with real write
    // Fire demo toast notification
    window.dispatchEvent(new CustomEvent('demo-mode-action', { detail: { action } }));
    return mockResult; // return mock result to prevent DB write
  };

  return { isDemoMode, interceptWrite };
};

export default useDemoMode;
